import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, IconButton, useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSelector } from "react-redux";
import { IMG_BASE_URL } from "../../utils/utils";

const MenuComponent = ({ MenuItems, handleMenuClick }) => {
  const { selectedMenuItem } = useSelector((store) => store?.Webshop);
  const scrollContainerRef = useRef(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);

  const menuCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Checkout fields + sidemnu"
  )?.fields


  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollButtons = () => {
    const el = scrollContainerRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    updateScrollButtons();
    const el = scrollContainerRef.current;
    if (!el) return;

    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);

    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [MenuItems]);


  const handleScroll = (direction) => {
    const el = scrollContainerRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.7; // scroll 70% of container width
    el.scrollBy({ left: direction === "right" ? scrollAmount : -scrollAmount, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        width: "100%",
        height: { xs: 120, sm: 140 },
        display: "flex",
        alignItems: "center",
        px: { xs: 1, sm: 4 },
    //    backgroundColor: "#FDFAF6",
    backgroundColor:menuCss?.menuListBgClr,
        backgroundImage: 'url(/path/to/your/background.jpg)', 
        backgroundSize: "cover",
        backgroundPosition: "center",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      {canScrollLeft && (
        <IconButton onClick={() => handleScroll("left")} sx={{ mr: 1 }}>
          <ArrowBackIosIcon />
        </IconButton>
      )}

      <Box
        ref={scrollContainerRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          gap: { xs: 1, sm: 2, md: 3 },
          flexGrow: 1,
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {MenuItems?.map((item, i) => {
          const isActive = selectedMenuItem?.name === item?.name;

          return (
            <Box
              key={i}
              onClick={() => handleMenuClick(item)}
              sx={{
                cursor: "pointer",
                flex: "0 0 auto",
                width: { xs: 80, sm: 100 },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  py: { xs: 1, sm: 1.5 },
                  backgroundColor:
                  selectedMenuItem?.name === item?.name
                    ? menuCss?.menuListHighlightBgClr
                    : "transparent",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: menuCss?.menuListHoverBgClr ?? "#FFD786",
                  cursor: "pointer"
                },
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                
                }}
              >
                {item?.imageFileName && (
                  <img
                    src={`${IMG_BASE_URL}/upload/WebshopCategory${item.imageFileName.replace(/\\/g, "/")}`}
                    alt={item?.name}
                    style={{
                      width: "70%",
                      height: "70%",
                      objectFit: "contain",
                      borderRadius: "12px",
                      marginBottom: "4px",
                    }}
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                )}
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "10px", sm: "11px" },
                    color:
                    selectedMenuItem?.name === item?.name
                      ? menuCss?.menuListHighlightTextClr
                      : menuCss?.menuListTextClr,
                    lineHeight: 1.2,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {item?.name}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
      {canScrollRight && (
        <IconButton onClick={() => handleScroll("right")} sx={{ ml: 1 }}>
          <ArrowForwardIosIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default MenuComponent;
